export const styles = {
  dateText: {
    fontWeight: "500",
    fontSize: ".625rem",
    opacity: ".6"
  },
  newsItemTitle: {
    margin: "0px",
    fontFamily: "Inter",
    lineHeight: "1.5",
    fontWeight: "600",
    fontSize: "0.75rem",
  },
  newsItem: {
    cursor: "pointer",
  },
  newsItemImage: {
    width: "48px",
    height: "48px",
    display: "block",
    objectFit: "cover",
    borderRadius: "8px"
  },
  allNewsArticleImage: {
    objectFit: "cover",
    borderRadius: "12px",
  },
  articleViewItemName: {
    fontWeight: "600",
    fontSize: "calc(1.125rem * var(--unicity-font-scale, 1))",
  },
  articleViewItemDate: {
    fontWeight: "500",
    fontSize: "calc(0.75rem * var(--unicity-font-scale, 1))",
    opacity: ".6",
    marginTop: "2px"
  },
  skeletonGridItem: {
    borderRadius: ".75rem"
  },
  articleCard: {
    height: "100%",
  },
  readMoreButton: {
    height: "35px",
    color: "#153862",
    backgroundColor: "#fff",
    borderRadius: "8px",
    border: "1px solid rgba(145, 158, 171, 0.20)",
    padding: "4px 4px 4px 12px",
    boxShadow: "none",
    "&:hover": {
      opacity: ".9",
      backgroundColor: "#fff",
      boxShadow: "none",
    }
  },
  readMoreButtonText: {
    fontWeight: "600",
    fontSize: ".75rem",
    textTransform: "none"
  },
};
